import React, { useEffect, useRef, useState } from "react";
import * as Shared from "../components/CivicShared";
const { api, copy, subCategories, wardPath, VIJAYANAGAR_WARDS, CIVIC_CATEGORIES, CIVIC_CATEGORIES_KN, Gate, SectionHeading, CivicStat, MiniAction, InfoCard, SimplePage, LocationPickerMap, Modal, FeedbackBox, NotFound, AlertCircle, ArrowLeft, ArrowRight, Bell, BriefcaseBusiness, Building2, Check, CheckCircle2, ChevronDown, Clock3, Eye, EyeOff, FileText, Globe2, HeartHandshake, Home, Lightbulb, LockKeyhole, LogIn, LogOut, Mail, MapPin, Menu, MessageCircle, MessageSquare, Phone, Search, ShieldCheck, Smartphone, UserCircle, UserRound, Users, X, MapContainer, TileLayer, useMapEvents } = Shared;

function ResidentProfile({ user, t, lang, onBack }) {
  const [profile, setProfile] = useState({
    name: user?.name || "",
    phone: "",
    email: user?.email || "",
    address: "",
    locality: "",
    ward: "",
    preferred_language: lang === "kn" ? "Kannada" : "English",
    notification_preferences: { in_app: true, email: false, sms: false },
    privacy_acknowledged: false,
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/me/profile")
      .then((r) => setProfile((p) => ({
        ...p,
        ...r.data,
        notification_preferences: {
          ...p.notification_preferences,
          ...(r.data.notification_preferences || {}),
        },
      })))
      .catch(() => setError("Unable to load profile."));
  }, []);

  const save = async (e) => {
    e.preventDefault();

    try {
      await api.patch("/me/profile", profile);
      setMessage("Profile saved successfully.");
      setError("");
    } catch (err) {
      setError(err.response?.data?.detail || "Unable to save profile.");
    }
  };

  return (
    <SimplePage title={t.profile} onBack={onBack}>
      <form className="profile-card" onSubmit={save}>
        <div className="profile-heading">
          <div className="profile-avatar">
            <UserCircle size={42} />
          </div>
          <div>
            <span className="eyebrow">RESIDENT PROFILE</span>
            <h2>{profile.name || "Resident"}</h2>
            <p>Manage the details used for civic-service communication.</p>
          </div>
        </div>

        <div className="profile-grid">
          <label>
            Name
            <input value={profile.name} onChange={(e) => setProfile({ ...profile, name: e.target.value })} required />
          </label>

          <label>
            Phone
            <input value={profile.phone} onChange={(e) => setProfile({ ...profile, phone: e.target.value })} />
          </label>

          <label className="profile-full">
            Email
            <input value={profile.email} disabled />
          </label>

          <label className="profile-full">
            Address
            <textarea rows="3" value={profile.address} onChange={(e) => setProfile({ ...profile, address: e.target.value })} />
          </label>

          <label>
            Locality
            <input value={profile.locality} onChange={(e) => setProfile({ ...profile, locality: e.target.value })} />
          </label>

          <label>
            Ward
            <select value={profile.ward} onChange={(e) => setProfile({ ...profile, ward: e.target.value })}>
              <option value="">Select ward</option>
              {VIJAYANAGAR_WARDS.map((w) => (
                <option value={w.value || w.number} key={w.number}>
                  Ward {w.number} - {w.name}
                </option>
              ))}
            </select>
          </label>

          <label>
            Preferred language
            <select value={profile.preferred_language} onChange={(e) => setProfile({ ...profile, preferred_language: e.target.value })}>
              <option>English</option>
              <option>Kannada</option>
            </select>
          </label>
        </div>

        <section className="profile-section">
          <h3>Notification Preferences</h3>

          <div className="profile-checks">
            {["in_app", "email", "sms"].map((key) => (
              <label className="profile-check" key={key}>
                <input
                  type="checkbox"
                  checked={!!profile.notification_preferences[key]}
                  onChange={(e) =>
                    setProfile({
                      ...profile,
                      notification_preferences: {
                        ...profile.notification_preferences,
                        [key]: e.target.checked,
                      },
                    })
                  }
                />
                <span>{key === "in_app" ? "In-app" : key.toUpperCase()}</span>
              </label>
            ))}
          </div>
        </section>

        <label className="profile-check">
          <input
            type="checkbox"
            checked={!!profile.privacy_acknowledged}
            onChange={(e) =>
              setProfile({ ...profile, privacy_acknowledged: e.target.checked })
            }
          />
          <span>
            I understand that the information I provide is used for civic-service
            purposes and communication about my submissions.
          </span>
        </label>

        {message && <div className="profile-success">{message}</div>}
        {error && <div className="profile-error">{error}</div>}

        <div className="profile-actions">
          <button type="button" className="civic-btn secondary" onClick={onBack}>
            Home
          </button>
          <button type="submit" className="civic-btn primary">
            Save Profile
          </button>
        </div>
      </form>
    </SimplePage>
  );
}


export default ResidentProfile;
